import { GlobalStateModel } from "@/models";
import { fetchAuthenticatedData } from "@/queries/shared";

type RawCalpadsElas = {
  ELAStatusCode: string;
  ELAStartDate: string;
  PrimaryLanguage: string;
  CorrectionReasonCode: string | null;
  GradeLevelCode: string;
};

type RawCalpadsSped = {
  SPEDStatus: string;
  SWDSStartDate: string;
  SWDSEntryStartDate: string;
  SPEDPlanTypeCode: string;
  PLANStartDate: string;
};

type RawCalpadsSyncResponse = {
  ssid: string;
  elas: RawCalpadsElas | null;
  sped: RawCalpadsSped | null;
};

export type CalpadsElasData = {
  elaStatusCode: string;
  elaStartDate: string;
  primaryLanguage: string;
  correctionReasonCode: string;
  gradeLevelCode: string;
};

export type CalpadsSpedData = {
  spedStatus: string;
  swdsStartDate: string;
  swdsEntryStartDate: string;
  spedPlanTypeCode: string;
  planStartDate: string;
};

export type CalpadsSyncData = {
  elas: CalpadsElasData | null;
  sped: CalpadsSpedData | null;
};

export async function fetchRealCalpadsSyncData(
  context: GlobalStateModel,
  ssid: string
): Promise<CalpadsSyncData | null> {
  const raw = await fetchAuthenticatedData<RawCalpadsSyncResponse>(
    context,
    `/json/state/calpads_lookup/${ssid}`
  );

  if (!raw) return null;

  return {
    elas: raw.elas
      ? {
          elaStatusCode: raw.elas.ELAStatusCode,
          elaStartDate: raw.elas.ELAStartDate,
          primaryLanguage: raw.elas.PrimaryLanguage,
          correctionReasonCode: raw.elas.CorrectionReasonCode ?? "",
          gradeLevelCode: raw.elas.GradeLevelCode,
        }
      : null,
    sped: raw.sped
      ? {
          spedStatus: raw.sped.SPEDStatus,
          swdsStartDate: raw.sped.SWDSStartDate,
          swdsEntryStartDate: raw.sped.SWDSEntryStartDate,
          spedPlanTypeCode: raw.sped.SPEDPlanTypeCode,
          planStartDate: raw.sped.PLANStartDate,
        }
      : null,
  };
}
